import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { floor } from 'lodash';
import Dialog from 'material-ui/Dialog';
import IconButton from 'material-ui/IconButton';
import { List, ListItem } from 'material-ui/List';

import get from 'lodash/get';
import includes from 'lodash/includes';
import KAvatar from '../components/KJRN/KAvatar';

const styles = {
  dialogTitle: {
    display: 'flex',
    alignItems: 'center',
  },
  avatar: {
    objectFit: 'cover',
    objectPosition: '50% 30%',
  },
  link: {
    outline: 'none',
    cursor: 'pointer',
  },
};

const fields = [
  {
    label: <div><FormattedMessage id="employeeSearch.title" /></div>,
    value: 'Title',
    searchLink: true,
    ID: 'EmployeeDetailOrg.OrgCompanyPositionName',
  },
  {
    label: <div><FormattedMessage id="employeeSearch.department" /></div>,
    value: 'Department',
    searchLink: true,
    ID: 'EmployeeDetailOrg.OrgCompanyUnitName',
  },
  {
    label: <div><FormattedMessage id="employeeSearch.costCenter" /></div>,
    value: 'CostCenter',
    searchLink: true,
    ID: 'EmployeeDetailOrg.OrgCompanyCostCenter',
  },
  {
    label: <div><FormattedMessage id="employeeSearch.division" /></div>,
    value: 'Division',
    searchLink: true,
    ID: 'EmployeeDetailOrg.OrgCompanyUnitDivisionName',
  },
  {
    label: <div><FormattedMessage id="employeeSearch.company" /></div>,
    value: 'Company',
    searchLink: true,
    ID: 'EmployeeDetailOrg.OrgCompanyName',
  },
  {
    label: <div><FormattedMessage id="employeeSearch.manager" /></div>,
    value: 'Manager',
    searchLink: true,
    searchLinkPrefix: 'manager:',
    ID: 'EmployeeDetailOrg.ManagerName',
  },
  {
    label: <div><FormattedMessage id="employeeSearch.phone" /></div>,
    value: 'Phone',
    ID: 'EmployeeMaster.PhoneNumberBuisness',
  },
  {
    label: <div><FormattedMessage id="employeeSearch.mobile" /></div>,
    value: 'Mobile',
    ID: 'EmployeeMaster.PhoneNumberMobile',
  },
  {
    label: <div><FormattedMessage id="employeeSearch.email" /></div>,
    value: 'Email',
    ID: 'EmployeeMaster.EmailWork',
  },
  {
    label: <div><FormattedMessage id="employeeSearch.location" /></div>,
    value: 'Location',
    ID: 'EmployeeDetailOrg.OrgLocationMain',
  },
];

const EmployeeSearchDialog = ({
  dialogOpen, dialogContent, inputValue, handleDialogClose, onClickSearch, valuesByKey,
}) => {

  const show = key => get(valuesByKey, [`Hide.${key}`, 'Value']) !== 'true';

  return (
    <Dialog
      contentStyle={{ overflow: 'hidden', minWidth: 310 }}
      open={dialogOpen}
      title={
        <div>
          <IconButton
            style={{ margin: -24, float: 'right' }}
            iconClassName="material-icons"
            onClick={handleDialogClose}
          >
            close
          </IconButton>
          <span style={styles.dialogTitle}>
            <KAvatar
              size={50}
              imgSrc={dialogContent.ImageUrl}
              masterId={floor(dialogContent.EmployeeDetailID / 10, 0)}
              style={{ ...styles.avatar, marginRight: 16 }}
            />
            {dialogContent.Name}
          </span>
        </div>
      }
      onRequestClose={handleDialogClose}
      autoScrollBodyContent
      modal
    >
      <List>
        {fields
          .filter(({ value, ID }) => dialogContent[value] && show(ID))
          .map(({
            label,
            value,
            searchLink,
            searchLinkPrefix,
          }, key) =>
            (<ListItem
              key={key}
              disabled
              style={{ padding: 8, backgroundColor: inputValue && includes(dialogContent[value], inputValue.replace(/manager:\s*/i, '')) ? '#fff4bf' : '' }}
              primaryText={searchLink ?
                <div style={styles.link} role="button" tabIndex="0" onKeyDown={null} onClick={() => onClickSearch(`${searchLinkPrefix || ''}${dialogContent[value]}`)} >{dialogContent[value]}</div> :
                dialogContent[value]}
              secondaryText={label}
            />))}
        {dialogContent.Qualifications &&
          <ListItem
            disabled
            style={{ padding: 8 }}
            secondaryText={<div><FormattedMessage id="qualification.title" /></div>}
            primaryText={dialogContent.Qualifications.length > 0 ?
              dialogContent.Qualifications.map(q => q.Qualification).join(', ') :
              <FormattedMessage id="panel.empty" />
            }
          />
        }
      </List>
    </Dialog>
  );
};

EmployeeSearchDialog.propTypes = {
  dialogOpen: PropTypes.bool.isRequired,
  dialogContent: PropTypes.object.isRequired,
  inputValue: PropTypes.string.isRequired,
  handleDialogClose: PropTypes.func.isRequired,
  onClickSearch: PropTypes.func.isRequired,
  valuesByKey: PropTypes.object.isRequired,
};

const mapStateToProps = ({ WebValuesReducer }) => ({ valuesByKey: WebValuesReducer.valuesByKey });

export default connect(mapStateToProps)(EmployeeSearchDialog);



// WEBPACK FOOTER //
// ./src/containers/EmployeeSearchDialog.js